import * as i0 from "@angular/core";
export class DisabledModule {
}
DisabledModule.ɵfac = function DisabledModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DisabledModule)(); };
DisabledModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DisabledModule });
DisabledModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
